<template>
  <el-dialog :modal-append-to-body="false" :visible.sync="visible" width="67vw" :before-close="onClose" title="包装采收记录">
    <el-form label-width="140px">
      <!-- 上半部分：与查看采收记录一致 -->
      <el-row :gutter="12" style="margin-bottom: 12px">
        <el-col :span="8">
          <el-form-item label="批次号">
            <div>{{ currentRecord && currentRecord.batchNumber }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="采收日期">
            <div>
              {{ formatDate(currentRecord && currentRecord.harvestDate) }}
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="基地名称">
            <div>{{ currentRecord && currentRecord.plantingBase }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="大棚编号">
            <div>{{ currentRecord && currentRecord.greenhouseName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="草莓品种">
            <div>{{ currentRecord && currentRecord.varietyName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="采收负责人">
            <div>{{ currentRecord && currentRecord.harvestManager }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="采收草莓总量 (kg)">
            <div>{{ currentRecord && currentRecord.sumWeight }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="仓储位置">
            <div>{{ currentRecord && currentRecord.basicStorageName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="品控员">
            <div>{{ currentRecord && currentRecord.reviewer }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="
          currentRecord &&
          currentRecord.attachment &&
          currentRecord.attachment.length
        ">
          <el-form-item label="附件">
            <div style="display: flex; gap: 8px; flex-wrap: wrap">
              <el-image v-for="(att, idx) in currentRecord.attachment" :key="idx" :src="att.url || att.path || att"
                style="width: 80px; height: 60px" fit="cover" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label=" 总包装重量">
        <div style="display: flex; gap: 8px; align-items: center">
          <div>
            <strong>{{ totalPackWeightDisplay }}</strong> kg
          </div>
          <div style="margin-left: 12px">
            坏果量：<strong>{{ lossWeightDisplay }}</strong> kg
            <span style="color: red; font-size: 12px; margin-left: 8px">
              注：坏果量=采收草莓总量-各分级规格重量
            </span>
          </div>
        </div>
      </el-form-item>

      <!-- 下半部分：包装明细编辑 -->
      <el-form-item label="包装明细">
        <el-table :data="localDtlList" border size="small" style="width: 100%">
          <el-table-column label="分级规格" width="160">
            <template slot-scope="{ row }">
              <el-select v-model="row.specSize" placeholder="请选择" size="small" style="width: 140px" clearable>
                <el-option v-for="opt in specOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="160">
            <template slot="header">
              重量 (kg)
            </template>
            <template slot-scope="{ row }">
              <el-input-number v-model="row.weight" :min="0" :step="0.1" :precision="3" @change="onDtlChange" />
            </template>
          </el-table-column>
          <el-table-column width="160">
            <template slot="header">包装数量（盒）</template>
            <template slot-scope="{ row }">
              <el-input-number v-model="row.boxes" :min="0" :step="1" :precision="0" @change="onDtlChange" />
            </template>
          </el-table-column>
          <el-table-column prop="basicStorageName" width="210">
            <template slot="header"> 仓储位置 </template>
            <template slot-scope="{ row }">
              <el-select v-model="row.basicStorageId" placeholder="请选择" size="small" style="width: 180px"
                @change="onStorageChange(row)" clearable>
                <el-option v-for="opt in storageOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">附件</template>
            <template slot-scope="{ row }">
              <div style="display: flex; gap: 8px; align-items: center">
                <ImageUpload v-model="row.attachment" :maxCount="3" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="{ $index }">
              <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="onDeleteRow($index)" />
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 12px">
          <el-button type="primary" style="width: 100%;" size="large" icon="el-icon-plus" @click="onAddRow">添加包装明细</el-button>
        </div>
      </el-form-item>
    </el-form>
<!-- CS2026010802 -->
    <div slot="footer" class="dialog-footer" style="text-align: right">
      <el-button @click="onClose">取消</el-button>
      <el-button @click="onSave(true)">保存为草稿</el-button>
      <el-button type="success" @click="onSave(false)">提交包装</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dayjs from "dayjs";
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";

import ImageUpload from "@/components/ImageUpload.vue";
export default {
  name: "PackingDialog",
  props: {
    visible: { type: Boolean, required: true },
    currentRecord: { type: Object, default: null },
    userInfo: { type: Object, default: null },
  },
  components: {
    ImageUpload,
  },
  data() {
    return {
      localDtlList: [],
      storageOptions: [],
      specOptions: [
        { label: "大果(特级果)", value: "LARGE" },
        { label: "中果(优质果)", value: "MEDIUM" },
        { label: "小果(精品果)", value: "SMALL" },
        { label: "次果", value: "INFERIOR" },
        { label: "宝宝果", value: "BABY" },
        { label: "蓝装草莓", value: "BASKET" },
      ],
    };
  },
watch: {
    currentRecord: {
      immediate: true,
      handler(n) {
        if (n) {
          // 默认空行模板
          const createEmptyRow = () => ({
            id: null,
            specSize: null,
            weight: 0,
            boxes: 0,
            basicStorageId: null,
            basicStorageName: "",
            attachment: [],
          });

          // 从现有数据获取，或使用默认一条空行
          let dtls = [];
          if (Array.isArray(n.harvestDtlList) && n.harvestDtlList.length) {
            // 转换现有数据
            dtls = n.harvestDtlList.map((it) => ({
              id: it.id || null,
              specSize: it.specSize || null,
              weight: it.weight || 0,
              boxes: it.boxes || 0,
              basicStorageId: it.basicStorageId || null,
              basicStorageName: it.basicStorageName || it.basicStorageName || "",
              attachment: Array.isArray(it.attachment)
                ? it.attachment.map((a) => a.url || a.path || a)
                : [],
            }));
          } else {
            // 没有数据时默认一条空行
            dtls = [createEmptyRow()];
          }
          this.localDtlList = dtls;
          this.fetchStorageOptions();
        } else {
          this.localDtlList = [];
        }
      },
    },
  },
  computed: {
    totalPackWeight() {
      return this.localDtlList.reduce(
        (s, r) => s + (parseFloat(r.weight) || 0),
        0
      );
    },
    totalPackWeightDisplay() {
      return this.totalPackWeight.toFixed(2);
    },
    lossWeight() {
      const totalHarvest =
        (this.currentRecord && parseFloat(this.currentRecord.sumWeight)) || 0;
      const loss = totalHarvest - this.totalPackWeight;
      return loss < 0 ? 0 : parseFloat(loss.toFixed(2));
    },
    lossWeightDisplay() {
      return this.lossWeight.toFixed(2);
    },
  },
  methods: {
    formatDate(v) {
      if (!v) return "";
      try {
        return dayjs(v).format("YYYY/MM/DD");
      } catch (e) {
        return v;
      }
    },
    onAddRow() {
      // 添加一条新的空行
      this.localDtlList.push({
        id: null,
        specSize: null,
        weight: 0,
        boxes: 0,
        basicStorageId: null,
        basicStorageName: "",
        attachment: [],
      });
    },
    onDeleteRow(index) {
      // 删除指定行的包装明细
      if (this.localDtlList.length <= 1) {
        this.$message &&
          this.$message.warning &&
          this.$message.warning("至少保留一条包装明细");
        return;
      }
      this.localDtlList.splice(index, 1);
    },
    async fetchStorageOptions() {
      // 尝试获取基础仓储选择项（若后端无该接口请替换或注释）
      const res = await axios.post(
        baseUrl + "/api/basic/storage-location/selection",
        { enableStatus: true }
      );
      if (res && res.code === 200 && Array.isArray(res.data)) {
        this.storageOptions = res.data.map((it) => ({
          label: it.storageName,
          value: it.id,
        }));
      }
    },
    onStorageChange(row) {
      // set name from options for display if available
      const opt = this.storageOptions.find(
        (o) => o.value === row.basicStorageId
      );
      row.basicStorageName = opt ? opt.label : "";
    },
    onDtlChange() {
      // reactive computed will update totals
    },
    // 使用 ImageUpload 组件管理附件，v-model 绑定为 row.attachment（URL 列表）
    async onSave(isDraft) {
      if (!this.currentRecord || !this.currentRecord.id) {
        this.$message &&
          this.$message.error &&
          this.$message.error("无效的采收记录");
        return;
      }

      // 提交包装时的校验
      if (!isDraft) {
        // 校验：每一条明细必须完整填写（分级规格和重量都必须有值）
        const invalidItems = this.localDtlList.filter(
          (row) => !row.specSize || !row.weight || parseFloat(row.weight) <= 0
        );
        if (invalidItems.length > 0) {
          this.$message &&
            this.$message.error &&
            this.$message.error("每条明细必须选择分级规格并填写重量");
          return;
        }
      }

      // 校验：包装明细填写的重量不能大于采收草莓总量
      const totalHarvest =
        (this.currentRecord && parseFloat(this.currentRecord.sumWeight)) || 0;
      // 使用组件的计算属性 totalPackWeight
      if (this.totalPackWeight - totalHarvest > 1e-6) {
        this.$message &&
          this.$message.error &&
          this.$message.error("包装明细总重量不能大于采收草莓总量");
        return;
      }

      const payload = {
        harvestId: this.currentRecord.id,
        isDraft: !!isDraft,
        lossWeight: this.lossWeight,
        harvestDtlList: this.localDtlList.map((d) => ({
          id: d.id || undefined,
          specSize: d.specSize || undefined,
          weight: d.weight || 0,
          boxes: d.boxes || 0,
          basicStorageId: d.basicStorageId || undefined,
          basicStorageName: d.basicStorageName || undefined,
          // send attachment as plain string array
          attachment: d.attachment || [],
        })),
      };
      try {
        const res = await axios.post(
          baseUrl + "/api/digital-farming/harvest/packing/order-packing",
          payload
        );
        if (res && (res.code === 200 || res.status === 200)) {
          this.$message &&
            this.$message.success &&
            this.$message.success(isDraft ? "已保存草稿" : "已提交包装");
          this.$emit("saved", { isDraft });
          this.onClose();
        } else {
          // some backends return data only
          this.$message &&
            this.$message.success &&
            this.$message.success(isDraft ? "已保存草稿" : "已提交包装");
          this.$emit("saved", { isDraft });
          this.onClose();
        }
      } catch (err) {
        console.error("包装保存失败:", err);
      }
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped></style>
